<template lang="pug">
  .component-map
    .container
      div.pt-2
        button.button.info(@click="showFilterPanel") Show Filter Panel
      GoogleMapContainer
        google-map(
          v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0",
          :searchBar="true",
          :api-key="mapsAPI",
          :center="mapCenter",
          :zoom=" 13",
          :mapTypeId="'roadmap'",
          :scrollwheel="false",
          @placesChanged="updateUserPosition",
          :zoomControl="true",
          :mapTypeControl="true",
          ref="map")
          .toggles(v-if="showfilter")
            .content
              h2 Filters
              select(v-model="body.active_vehicle_slots")
                option(:value="null") All
                option(:value="1") Enabled
                option(:value="0") Disabled
              label Booking Mode
              select(v-model="body.reservation_type")
                option(:value="null") All
                option(v-for="(reservation_type, key) in reservation_types", :selected="value === key", :value="key") {{reservation_type}}
              label Vehicle Type
                selectize-vehicle-type(@optionSelected="optionSelected", @optionRemoved="optionRemoved")
                ActionButton(:action="loadVehicles" ) Apply filters
              label License plate
                input(type="text", v-model="plate", @input="filter")
            .content
              h2 Zones
            .button-group.stacked.small
              button.button.secondary(:class="{success:showAllowed}", @click="showAllowed = !showAllowed") Allowed
              button.button.secondary(:class="{warning:showUndesirable}", @click="showUndesirable = !showUndesirable") Undesirable
              button.button.secondary(:class="{alert:showForbidden}", @click="showForbidden = !showForbidden") Forbidden
          .allowed(v-if="showAllowed", v-for="(allowed) in zones['allowed']")
            google-map-polygon(v-for="poly in allowed.poly", :positions="poly", color="green", fillColor="green")
          .forbidden(v-if="showForbidden", v-for="(forbidden) in zones['forbidden']")
            google-map-polygon(v-for="poly in forbidden.poly", :positions="poly", color="red", fillColor="red")
          .undesirable(v-if="showUndesirable", v-for="(undesirable) in zones['undesirable']")
            google-map-polygon(v-for="poly in undesirable.poly", :positions="poly", color="yellow", fillColor="yellow")
          google-map-marker-cluster
            google-map-marker(
              v-for='vehicle in filteredVehicles',
              :key='vehicle.plate',
              :icon="vehicleInRange(vehicle)",
              :position="{lat: vehicle.position.latitude, lng: vehicle.position.longitude}",
              :title='vehicle.model',
              :label="vehicle.model",
              :labelOrigin="[15,30]",
              @click="updateSelectedVehicle"
            )
              vehicle(:item="vehicle", :type="'fleet-map'")



    //map2
        marker2(v-for='vehicle in vehicles', :key='vehicle.id', :icon="vehicleInRange(vehicle.in_range)", :position="vehicle.position", :title='vehicle.model', :label="vehicle.model")
            vehicle(:item="vehicle", :type="'fleet-map'")
        circle2(v-for='vehicle in vehicles', :key='vehicle.parking_lot.id', v-if="vehicle.parking_lot.id !== null", :radius="50", :position="vehicle.parking_lot.position")
            span {{vehicle.parking_lot.name}}
            span PL{{vehicle.parking_lot.id}}
</template>
<script type="text/babel">

import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import Vehicle from 'components/backoffice/Vehicle'
import GoogleMap from '../../lib/map/GoogleMap.vue'
import GoogleMapMarker from '../../lib/map/GoogleMapMarker.vue'
import GoogleMapCircle from '../../lib/map/GoogleMapCircle.vue'
import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
import GoogleMapMarkerCluster from '../../lib/map/GoogleMapMarkerCluster.vue'
import GoogleMapDirectionsService from '../../lib/map/GoogleMapDirectionsService'
import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'
import SelectizeVehicleType from '../../components/structure/ui/lists/selectize/SelectizeVehicleType'
import ActionButton from '../../components/structure/ui/ActionButton'
import InputSwitch from '../../components/structure/ui/InputSwitch'

export default {
  name: 'FleetMap',
  data() {
    return {
      showfilter: false,
      vehicles: null,
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      userPosition: null,
      vehiclePosition: null,
      zones: [],
      showAllowed: true,
      showForbidden: true,
      showUndesirable: true,
      plate: null,
      body: {
        vehicle_type_id: null,
        active_vehicle_slots: null,
        reservation_type: null,
        page_number: 1,
        per_page: -1
      },
      filtered: [],
      reservation_types: []
    }
  },
  methods: {
    optionSelected(obj) {
      this.body.vehicle_type_id = obj.id
    },
    optionRemoved() {
      this.body.vehicle_type_id = null
    },
    loadVehicles() {
      return KeplerBackofficeSdk.vehicles.list().fleetMap(this.body, (data) => {
        this.vehicles = data.items
      })
    },
    filter(evt) {
      const plate = evt.target.value
      this.filtered = this.vehicles.filter((vehicle) => {
        return vehicle.plate.includes(plate)
      })
    },
    vehicleInRange(vehicle) {
      let icon = '/static/map_pin_blue.png'
      if (!vehicle.in_range) {
        icon = '/static/map_pin_red.png'
      }

      if(vehicle.has_reservation === 'normal') {
        icon = '/static/map_pin_orange.png'
      }

      if(vehicle.has_reservation === 'maintenance') {
        icon = '/static/map_pin_yellow.png'
      }

      if (vehicle.ev_plug_status === 'CHARGING'){
        icon = '/static/charging.svg'

      }

      return icon
    },
    updateUserPosition(position) {
      this.userPosition = position.location
    },
    updateSelectedVehicle(position) {
      this.vehiclePosition = position.latLng
    },
    showFilterPanel() {
      this.showfilter = !this.showfilter
    }
  },
  components: {
    InputSwitch,
    ActionButton,
    SelectizeVehicleType,
    GoogleMapContainer,
    GoogleMapDirectionsService,
    Vehicle,
    GoogleMap,
    GoogleMapMarker,
    GoogleMapCircle,
    GoogleMapMarkerCluster,
    GoogleMapPolygon
  },
  computed: {
    mapsAPI: function () {
      return window.env.GOOGLE_MAPS_KEY
    },
    filteredVehicles() {
      return this.plate === null || this.plate === '' ? this.vehicles : this.filtered
    }
  },
  created() {
    this.loadVehicles()
  },
  mounted() {
    KeplerBackofficeSdk.configuration.get((data) => {
      this.mapCenter.lat = data.application.application_default_latitude.value
      this.mapCenter.lng = data.application.application_default_longitude.value
    })

    KeplerBackofficeSdk.zones.list.grouped((data) => {
      this.zones = data
    })

    KeplerBackofficeSdk.reservations.list().modes((data) => {
      Object.keys(data).map((key) => {
        data[key] = data[key].replace('App\\Models\\ConcreteReservations\\', '').replace('Reservation', '');
      });

      this.reservation_types = data;
    })
  }
}


</script>
<style lang="sass" rel="stylesheet/sass">
.component-map
  width: 100%

  .toggles
    position: absolute
    padding: 2em
    right: 0
    background: white
    width: 300px

    .content
      display: flex
      text-align: center
      flex-direction: column
      justify-content: center
</style>



// WEBPACK FOOTER //
// FleetMap.vue?6c337b2e